__turbopack_context__.v({
  "chartContainer": "Chart-module-scss-module__-WJ-2W__chartContainer",
  "marketChartWrapper": "Chart-module-scss-module__-WJ-2W__marketChartWrapper",
});
